import React from 'react';
import { MapSearch } from '../../../components';

import './style.scss';

const ParagraphMap = () => {
  return (
    <div className="Paragraph ParagraphMap">
      <MapSearch />
    </div>
  );
};

export default ParagraphMap;
